import React, { lazy } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';

// project imports
import NavMotion from './../layout/NavMotion';
import Loadable from '../ui-component/Loadable';

// Buyer-facing WhatsApp payment-link page. No CRM login involved — the
// order/token is resolved server-side, so this deliberately skips both
// GuestGuard and the authenticated MainLayout (sidebar/header) other routes use.
const PaymentPage = Loadable(lazy(() => import('../views/pages/PaymentPage')));

const PaymentPageRoutes = () => {
    const location = useLocation();

    return (
        <Route path={['/pay/:token']}>
            <Switch location={location} key={location.pathname}>
                <NavMotion>
                    <Route path="/pay/:token" component={PaymentPage} />
                </NavMotion>
            </Switch>
        </Route>
    );
};

export default PaymentPageRoutes;
